import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaCalendarAlt, FaUser, FaArrowLeft } from 'react-icons/fa';
import ImageGallery from '../components/ImageGallery/ImageGallery';
import './NoticiaDetalhe.css';
import API_BASE_URL from '../config/api';

const NoticiaDetalhe = () => {
    const { slug } = useParams();
    const [news, setNews] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        fetchNewsDetail();
    }, [slug]);

    const fetchNewsDetail = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/news/${slug}`);
            if (response.ok) {
                const data = await response.json();
                setNews(data);
            } else {
                setError(true);
            }
        } catch (error) {
            console.error('Error fetching news detail:', error);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    const getImageUrl = (imageUrl) => {
        if (!imageUrl) return '/CDP_logo.png';
        if (imageUrl.startsWith('http')) return imageUrl;
        return `${API_BASE_URL}${imageUrl.startsWith('/') ? imageUrl : '/' + imageUrl}`;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-PT', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });
    };

    // Lightweight inline markdown parser: **bold** and *italic* (for legacy content)
    const renderContent = (content) => {
        // Detect if content is HTML (from WYSIWYG editor) or plain text
        const isHtml = /<[a-z][\s\S]*>/i.test(content);
        if (isHtml) {
            return <div className="noticia-body" dangerouslySetInnerHTML={{ __html: content }} />;
        }
        // Legacy plain-text fallback: convert markdown + split by newline
        const html = content
            .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.+?)\*/g, '<em>$1</em>')
            .split('\n')
            .map(line => `<p>${line}</p>`)
            .join('');
        return <div className="noticia-body" dangerouslySetInnerHTML={{ __html: html }} />;
    };

    if (loading) {
        return (
            <div className="noticia-loading">
                <div className="spinner"></div>
                <p>A carregar notícia...</p>
            </div>
        );
    }

    if (error || !news) {
        return (
            <div className="noticia-error">
                <h2>Notícia não encontrada</h2>
                <p>A notícia que procura não existe ou foi removida.</p>
                <Link to="/noticias" className="btn-back">
                    <FaArrowLeft /> Voltar às Notícias
                </Link>
            </div>
        );
    }

    return (
        <div className="noticia-detalhe-page">
            <header className="noticia-header">
                <div className="container noticia-header-content">
                    <span className="noticia-category">{news.category}</span>
                    <h1>{news.title}</h1>
                    <div className="noticia-meta">
                        <span>
                            <FaCalendarAlt /> {formatDate(news.publishedAt)}
                        </span>
                    </div>
                </div>
            </header>

            <div className="noticia-container">
                <div className="noticia-content-wrapper">
                    {/* Combined Image Gallery: Featured image + Gallery images */}
                    {(() => {
                        const allImages = [];

                        if (news.imageUrl) {
                            allImages.push(getImageUrl(news.imageUrl));
                        }

                        if (news.galleryImages && news.galleryImages.length > 0) {
                            const galleryUrls = news.galleryImages.map(img => getImageUrl(img.imageUrl));
                            allImages.push(...galleryUrls);
                        }

                        if (allImages.length > 0) {
                            return (
                                <ImageGallery
                                    images={allImages}
                                    alt={news.title}
                                />
                            );
                        }

                        return null;
                    })()}

                    {renderContent(news.content)}

                    <div style={{ marginTop: '40px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
                        <Link to="/noticias" className="btn-back" style={{ background: 'transparent', color: '#003380', border: '1px solid #003380' }}>
                            <FaArrowLeft /> Voltar à lista de notícias
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoticiaDetalhe;
